import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { SwingWtSuffix } from '../../api/models';

export type TABLE_TYPE = Table<SwingWtSuffix>;

export const TABLE = 'swingWtSuffix';
const SCHEMA = 'swingWtSuffixId, sortId';

class SwingWtSuffixDatabase implements DataRepository<SwingWtSuffix> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<SwingWtSuffix | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: SwingWtSuffix, key: Key): Promise<SwingWtSuffix> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: SwingWtSuffix[]): Promise<SwingWtSuffix[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<SwingWtSuffix[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const SwingWtSuffixDB = new SwingWtSuffixDatabase(db);
